export const iconFontAwesomeCodingBoxArchive = (
	<i className="fa-solid fa-box-archive"></i>
);
